import _ from 'lodash';
export function getViewDataOutDto(data) {
    const { available_fields, fields_structure } = data;
    data.custom_fields = [];
    _.forEach(available_fields, field => {
        const fieldStructure = fields_structure[field];
        if (fieldStructure.is_custom)
            data.custom_fields.push(fieldStructure);
    });
    return data;
}
